import { FC, useContext, useEffect} from "react";
import { DownloadPracticeResponseTypeApi, ModalTypeProps } from "./types";
import { formatPhoneNumber } from "src/helpers";
import { format, parse } from "date-fns";
import { LoaderContext } from "src/context/loaderContext";
import { APIEndpoints } from "src/types/apiTypes";
import useFetch from "src/hooks/useFetch";
import { downloadExcelFile } from "src/helpers/downloadFile";
import { StatsContext } from "src/context/statsContext";


const Modal: FC<ModalTypeProps> = ({ title, data, onClick }): JSX.Element => {
  const { setLoader, hideLoader } = useContext(LoaderContext)
  const { state } = useContext(StatsContext);

  

  const {
    data: downloadReportsData, error: downloadReportsError, mutate: downloadRequestForm, removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadPracticeResponseTypeApi>(APIEndpoints.MANUFACTURE_STATISTICS_REPORT_DOWNLOAD);

  useEffect(() => {
    if (downloadReportsData || downloadReportsError) {
      if (downloadReportsData){
        const { response, report_name } = downloadReportsData;
        downloadExcelFile(response, `${report_name}.xlsx`);
      }
      hideLoader();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadReportsData, downloadReportsError]);


  const downloadReport = () => {
    if (downloadReportsData || downloadReportsError) clearRequestFileData();
    setLoader();
    const params = {
      start_date: state.start_date,
      end_date: state.end_date,
      report_name: "practice_report",
    }
    downloadRequestForm({}, {}, params);
  }




  const overFlowBackground = () => {
    document.body.style.overflow = 'unset';
  }

  return (
    <div   style={{ display: title && title.length > 0 ? 'block' : 'none' }} className= {`modal fade loader-index ${title && title.length > 0 ? 'show show-modal' : ''}`} id="typeModal" aria-labelledby="typeModalLabel">
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title" id="typeModalLabel">{title}</h4>
            <button type="button" className="btn btn-primary py-1 px-5 ms-3" onClick={downloadReport}>
              Download
            </button>
            <button type="button" className="btn-close" data-bs-dismiss="modal"
              aria-label="Close" 
              onClick={() => {
                onClick()
                overFlowBackground()
              }}
            ></button>
          </div>
          <div className="modal-body p-0">
            <table className="table table-striped table-hover table-responsive position-relative m-0">
              <thead className="sticky-top">
                <tr>
                  <th scope="col" className="text-center fs-6">Region</th>
                  <th scope="col" className="text-center fs-6">Territory</th>
                  <th scope="col" className="text-center fs-6">Practice Name</th>
                  <th scope="col" className="text-center fs-6">State</th>
                  <th scope="col" className="text-center fs-6 col-3">Phone</th>
                  <th scope="col" className="text-center fs-6 col-3">Added</th>
                </tr>
              </thead>
              <tbody>
                {data && data.length > 0 ?
                  data.map((item, index) =>
                    <tr key={index}>
                      <td className="text-center text-17 text-wrap text-break">{item.region_name || ""}</td>
                      <td className="text-center text-17 text-wrap text-break">{item.territory_name || ""}</td>
                      <td className="text-center text-17 text-wrap text-break">{item.name || ""}</td>
                      <td className="text-center text-17">{item.state}</td>
                      <td className="text-center text-17">
                        {item.phone_number ? formatPhoneNumber(item.phone_number) : ""}
                      </td>
                      <td className="text-center text-17">
                        {item.created_at && format(parse(item.created_at, "yyyy-MM-dd", new Date()), "MM/dd/yyyy")}
                      </td>
                    </tr>
                  )
                  : null}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
